import {
  REACT_APP_API_URL,
  REACT_APP_OAUTH2_AUDIENCE,
  REACT_APP_OAUTH2_CLIENTID,
  REACT_APP_OOLIO_DOMAIN,
  REACT_APP_KDS_SERVICE_URI,
  REACT_APP_SUBSCRIPTION_URI,
  REACT_APP_HEALTH_CHECK_URL,
} from 'react-native-dotenv';

const config = {
  SERVICE_URI: process.env['REACT_APP_API_URL'] || REACT_APP_API_URL,
  KDS_SERVICE_URI:
    process.env['REACT_APP_KDS_SERVICE_URI'] || REACT_APP_KDS_SERVICE_URI,
  SUBSCRIPTION__URL:
    process.env['REACT_APP_SUBSCRIPTION_URI'] || REACT_APP_SUBSCRIPTION_URI,
  // Reachability probe target for the online/offline indicator. Must return 200
  // and allow CORS from the app origin (the oolio health endpoint does both).
  HEALTH_CHECK_URL:
    process.env['REACT_APP_HEALTH_CHECK_URL'] ||
    REACT_APP_HEALTH_CHECK_URL ||
    'https://ok.oolio.dev',
  DEFAULT_COUNTRY_CODE: 'AU',
  DEFAULT_LOCALE: 'en-US',
  auth0: {
    issuer:
      'https://auth.' +
      (process.env['REACT_APP_OOLIO_DOMAIN'] || REACT_APP_OOLIO_DOMAIN),
    clientId:
      process.env['REACT_APP_OAUTH2_CLIENTID'] || REACT_APP_OAUTH2_CLIENTID,
    redirectUrl: '',
    additionalParameters: {
      audience:
        process.env['REACT_APP_OAUTH2_AUDIENCE'] || REACT_APP_OAUTH2_AUDIENCE,
    },
    scopes: ['openid', 'profile', 'email', 'offline_access'],
  },
};

export default config;
